/* eslint-disable import/no-named-as-default-member */
/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */
import _ from 'lodash';
import { createSelector } from 'reselect';
import { ROOT_SLICE } from '../constants';
import { selectRootSliceFCCJ } from '../../../Main/selectors';



export const selectThisSlice = state => { 
  const slice = selectRootSliceFCCJ(state);
  if (slice[ROOT_SLICE]) { 
    return slice[ROOT_SLICE];
  }
  return state; // else assume state is already this slice.
};

export const selectSelectedItem = state => {
	const slice = selectThisSlice(state);
	const { selectedItem } = slice;
	return selectedItem;
};

export const selectSelectedItemChangesClone = state => {
	const slice = selectThisSlice(state);
	const { selectedItemChangesClone } = slice;
	return selectedItemChangesClone;
};

export const selectIsSavingItem = state => {
	const slice = selectThisSlice(state);
	const { isSavingItem } = slice;
	return isSavingItem;
};

export const selectHasChanges = createSelector(
	selectSelectedItem,
	selectSelectedItemChangesClone,
	(selectedItem, selectedClone) => {
		const item = _.cloneDeep(selectedItem) || {};
		const clone = _.cloneDeep(selectedClone) || {};

		return item && clone && !_.isEqual(item, clone);
	}
);

export const selectNewItem = state => {
	const slice = selectThisSlice(state);
	const { newItem } = slice;
	return newItem;
};

export const selectIsSavingNewItem = state => {
	const slice = selectThisSlice(state);
	const { isSavingNewItem } = slice;
	return isSavingNewItem;
};

export const selectErrorMessageSaveNewItem = state => {
	const slice = selectThisSlice(state);
	const { errorMessageSaveNewItem } = slice;
	return errorMessageSaveNewItem;
};

export const selectIsSavingEditedItem = state => {
	const slice = selectThisSlice(state);
	const { isSavingEditedItem } = slice;
	return isSavingEditedItem;
};

export const selectErrorMessageSaveEditedItem = state => {
	const slice = selectThisSlice(state);
	const { errorMessageSaveEditedItem } = slice;
	return errorMessageSaveEditedItem;
};

export const selectIsDeletingItem = state => {
	const slice = selectThisSlice(state);
	const { isDeletingItem } = slice;
	return isDeletingItem;
};

export const selectErrorMessageDeleteItem = state => {
	const slice = selectThisSlice(state);
	const { errorMessageDeleteItem } = slice;
	return errorMessageDeleteItem;
};

export const selectShowConfirmation = state => {
	const slice = selectThisSlice(state);
	const { showConfirmation } = slice;
	return showConfirmation;
};

export const selectConfirmationMessageKey = state => {
	const slice = selectThisSlice(state);
	const { confirmationMessageKey } = slice;
	return confirmationMessageKey;
};
